import React, { Component } from 'react';
import axios from 'axios';
import axiosRetry from 'axios-retry';
import { Table, Image, Header, Statistic } from 'semantic-ui-react';
import DemographicsAgeGraph from 'dyzio-shared-components/lib/components/demographics-age-graph';
import numeral from 'numeral';

import Error from '../../components/error';
import Loading from '../../components/loading';
import PostsTable from './posts-table';

const _ = require('lodash');


const tabulateDemographics = demographics => {
  const demographicsTable = {};
  const AGE_BUCKET_REGEX = /([a-zA-Z])+/gi;
  const total = {
    M: 0,
    F: 0,
  };
  _.map(demographics, (value, key) => {
    const [gender, ageGroup] = _.tail(_.split(key, AGE_BUCKET_REGEX));
    total[gender] += value.percentage;
    if (!demographicsTable[ageGroup]) {
      demographicsTable[ageGroup] = {};
    }
    demographicsTable[ageGroup][gender] = value;
  });
  const demographicsArray = Object.entries(demographicsTable);
  console.log(demographicsArray);
  demographicsArray.sort((a, b) => {
    const [aValue] = _.tail(a);
    const [bValue] = _.tail(b);
    return (bValue.M.percentage + bValue.F.percentage) -
    (aValue.M.percentage + aValue.F.percentage);
  });
  console.log(total);
  return {
    demographicsTable: demographicsArray,
    total,
  };
};

class Profile extends Component {
  constructor() {
    super();
    this.state = {};
    this.client = axios.create({
      // baseURL: process.env.REACT_APP_API_URL,
      baseURL: 'https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production/profile',
      timeout: 10000,
    });

    axiosRetry(this.client, {
      retries: 3,
      delay: 100,
      retryCondition: error => !error.response || (error.response.status >= 500 && error.response.status <= 599),
    });
  }

  componentDidMount = () => {
    console.log(this.props.match);
    const { id } = this.props.match.params;

    const noop = _.noop();
    console.log(noop);

    console.log(`profileId: ${id}`);
    // put the email into local storage
    // https://www.npmjs.com/package/localStorage
    // https://www.npmjs.com/package/local-storage

    // create a form with name and email
    this.setState({
      profileId: id,
    });

    this.client.get(`/${id}`)
      .then(r => {
        const profile = r.data;
        console.log('vvvvv');
        console.log(profile.rawInstagramPosts);
        console.log(888);
        this.setState({
          loading: false,
          profile,
        });
      })
      .catch(error => {
        window.onerror(error);
        console.log('err', error);
        // this.setState({
        //   error,
        // });
      });
  }


  render = () => {
    const { profile, error } = this.state;
    const audienceDemographics = { data: _.get(profile, 'demographics.dyzioDemographics') };
    const { demographicsTable, total } = tabulateDemographics(audienceDemographics.data);

    const locations = _.get(profile, 'locations.locations');

    const adPosts = _.filter(_.get(profile, 'rawInstagramPosts'), 'isAd');


    if (profile) {
      const { advancedAudienceQuality, basicAudienceQuality } = profile.demographics;
      const { instagramEngagementRate, instagramCount } = profile;
      let meanPosts = null;
      let accountsWithLowPosts = null;
      if (advancedAudienceQuality) {
        meanPosts = Math.round(_.meanBy(advancedAudienceQuality, 'postCount'));
        accountsWithLowPosts = _.size(_.filter(advancedAudienceQuality, aq => aq.postCount < 10));
      }

      return (
        <div style={{ textAlign: 'center' }}>
          <h1>{profile.primarySocialHandle}</h1>
          <div style={{ backgroundColor: '#fff', border: '3px solid #fc4085', padding: 10, margin: 15 }}>
            <Image src={profile.thumbnail} size="medium" centered circular />
          </div>

          <div>Profile</div>
          <pre>{ profile.instagramBio}</pre>

          <div style={{ backgroundColor: '#fff', border: '3px solid #fc4085', padding: 25, margin: 15 }}>
            <h1>Audience age and gender for Instagram</h1>
            <h5>Channel demographic by gender / age</h5>
            <DemographicsAgeGraph audienceDemographics={audienceDemographics} />
            <Table basic="very" columns="three" singleLine textAlign="center" sortable="true">
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell textAlign="left">Age Group</Table.HeaderCell>
                  <Table.HeaderCell>Male</Table.HeaderCell>
                  <Table.HeaderCell>Female</Table.HeaderCell>
                  <Table.HeaderCell>Total</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {
                  _.map(demographicsTable, ([key, value]) => <Table.Row>
                    <Table.Cell textAlign="left">
                      {key}
                    </Table.Cell>
                    <Table.Cell>
                      {value.M.percentage}%
                    </Table.Cell>
                    <Table.Cell>
                      {value.F.percentage}%
                    </Table.Cell>
                    <Table.Cell>
                      {numeral(value.M.percentage + value.F.percentage).format('0.0')}%
                    </Table.Cell>
                  </Table.Row>)
                }
                <Table.Row>
                  <Table.Cell textAlign="left">
                        Total
                  </Table.Cell>
                  <Table.Cell>
                    <Header as="b" textAlign="center">
                      {numeral(total.M).format('0.0')}%
                    </Header>
                  </Table.Cell>
                  <Table.Cell>
                    <Header as="b" textAlign="center">
                      {numeral(total.F).format('0.0')}%
                    </Header>
                  </Table.Cell>
                  <Table.Cell />
                </Table.Row>
              </Table.Body>
            </Table>
          </div>

          <div style={{ backgroundColor: '#fff', border: '3px solid #fc4085', padding: 25, margin: 15 }}>
            <h1>Audience Locations by country (for Instagram)</h1>
            <h5>Location by Country</h5>
            <Table basic="very" columns="one" singleLine textAlign="center" sortable="true">
              {
                _.map(_.take(_.get(locations, 'countryData'), 5), country => <Table.Row>
                  <Table.Cell textAlign="center">
                    {country.id} - {numeral(country.count * 100 / locations.total).format('0.0')}%
                  </Table.Cell>
                </Table.Row>)
              }
            </Table>
          </div>


          <div style={{ backgroundColor: '#fff', border: '3px solid #fc4085', padding: 25, margin: 15 }}>
            <h1>Audience Quality</h1>
            {
              instagramCount &&
              <Statistic color="blue">
                <Statistic.Value>{numeral(instagramCount).format('0a')}</Statistic.Value>
                <Statistic.Label>FOLLOWERS</Statistic.Label>
              </Statistic>
            }
            {
              instagramEngagementRate &&
              <Statistic color="pink">
                <Statistic.Value>{instagramEngagementRate}</Statistic.Value>
                <Statistic.Label>ENG RATE</Statistic.Label>
              </Statistic>
            }

            {
              meanPosts &&
              <Statistic>
                <Statistic.Value>{meanPosts}</Statistic.Value>
                <Statistic.Label>avg. posts</Statistic.Label>
              </Statistic>
            }

            {
              accountsWithLowPosts &&
              <Statistic>
                <Statistic.Value>{accountsWithLowPosts}</Statistic.Value>
                <Statistic.Label>Less than 10 posts</Statistic.Label>
              </Statistic>
            }

            {
              basicAudienceQuality &&
              <Statistic>
                <Statistic.Value>{basicAudienceQuality.isVerified}</Statistic.Value>
                <Statistic.Label>Verified</Statistic.Label>
              </Statistic>
            }

            {
              basicAudienceQuality &&
              <Statistic>
                <Statistic.Value>{basicAudienceQuality.isPrivate}</Statistic.Value>
                <Statistic.Label>Private</Statistic.Label>
              </Statistic>
            }
          </div>

          {
            profile.rawInstagramPosts &&
            <div style={{ backgroundColor: '#fff', border: '3px solid #fc4085', padding: 25, margin: 15 }}>
              <h1>Top 3 Posts (engagements)</h1>
              <PostsTable posts={_.take(_.orderBy(profile.rawInstagramPosts, 'engagementCount', ['desc']), 3)} />
            </div>
          }

          {
            !_.isEmpty(adPosts) &&
            <div style={{ backgroundColor: '#fff', border: '3px solid #fc4085', padding: 25, margin: 15 }}>
              <h1>Most Recent Ad Posts</h1>
              <PostsTable posts={_.take(_.orderBy(adPosts, 'commentCount', ['desc']), 3)} />
            </div>
          }

          {
            profile.rawInstagramPosts &&
            <div style={{ backgroundColor: '#fff', border: '3px solid #fc4085', padding: 25, margin: 15 }}>
              <h1>Latest 50 posts</h1>
              <PostsTable posts={profile.rawInstagramPosts} />
            </div>
          }

        </div>
      );
    }

    if (error) {
      return (
        <Error error={error} />
      );
    }

    return (
      <Loading resource="profile" />
    );
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/containers/profile/index.js